import React from 'react';
import {ScrollView, View} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import theme from '@/style';
import DetailNavTitle from '@/components/business/detail-nav-title';
import i18n from '@/i18n';
import Text from '@/components/basic/text';
import InvitationRuleTable from './invitation-rule-table';
import {goBack} from '@/utils';
import InvitationRuleContent from './invitation-rule-content';

const InvitationRule = () => {
  const {
    size: {screenHeight},
    whiteSpaceStyle,
  } = useInnerStyle();
  return (
    <View
      style={[
        {height: screenHeight},
        theme.fill.fillW,
        theme.flex.col,
        theme.background.lightGrey,
      ]}>
      <DetailNavTitle
        hideAmount
        serverRight
        title={i18n.t('invitation.rule.title')}
        onBack={goBack}
      />
      <ScrollView style={[theme.flex.flex1]}>
        <View style={[theme.flex.col, theme.padding.l, whiteSpaceStyle.bottom]}>
          <View
            style={[
              theme.flex.col,
              theme.padding.l,
              theme.background.white,
              theme.margin.btml,
              theme.borderRadius.m,
            ]}>
            <Text main size="medium">
              {i18n.t('invitation.rule.paragraph.invite')}
            </Text>
            <Text main size="medium" style={[theme.margin.topl]}>
              {i18n.t('invitation.rule.paragraph.after')}
            </Text>
          </View>
          <InvitationRuleTable />
          <InvitationRuleContent />
        </View>
      </ScrollView>
    </View>
  );
};

export default InvitationRule;
